const PAGE_PERMISSIONS = {
  // '/': [
  //   'SuperAdmin',
  //   'Admin',
  //   'Manager',
  //   'Dispatch',
  //   'LeadTech',
  //   'InShopTech',
  //   'DiagCoord',
  //   'MasterTech',
  //   'ReviewTech'
  // ],
  // '/login': [
  //   'SuperAdmin',
  //   'Admin',
  //   'Manager',
  //   'Dispatch',
  //   'LeadTech',
  //   'InShopTech',
  //   'DiagCoord',
  //   'MasterTech',
  //   'ReviewTech'
  // ],
  '/partner': [
    'SuperAdmin',
    'Admin'
  ],
  '/partner/create': [
    'SuperAdmin',
    'Admin'
  ],
  '/partner/update': [
    'SuperAdmin',
    'Admin'
  ],
  '/business': [
    'SuperAdmin',
    'Admin'
  ],
  '/business/create': [
    'SuperAdmin',
    'Admin'
  ],
  '/business/update': [
    'SuperAdmin',
    'Admin'
  ],
  '/dashboard/requests': [
    'SuperAdmin',
    'Admin'
  ],
  '/dashboard/statistics': [
    'SuperAdmin',
    'Admin'
  ],
  '/dashboard/devicestatistics': [
    'SuperAdmin',
    'Admin'
  ],
  '/dashboard/activationcardstatistics': [
    'SuperAdmin',
    'Admin'
  ],
  '/dashboard/businessaccountsinfo': [
    'SuperAdmin',
    'Admin'
  ],
  '/dashboard/deviceshipments': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/defaults': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/salesreps': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/translation': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/service-element-translation': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/message': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/devices': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/device-files': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/device-file-detail': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/report': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/maintenance': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/calibrate': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/mobile': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/files': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/chat': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/scanpro': [
    'SuperAdmin',
    'Admin'
  ],
  '/users': [
    'SuperAdmin',
    'Admin'
  ],
  '/users/create': [
    'SuperAdmin',
    'Admin'
  ],
  '/users/update': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/makes': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/calibration-homepage-message': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/openinghours': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/openinghours/opening-hours': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/openinghours/auditLog': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/rag': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/rag/auditLog': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/rag/maintenance': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/rag/Translations (Service Elements)': [
    'SuperAdmin',
    'Admin'
  ],
  '/admin/device-detail': [
    'SuperAdmin',
    'Admin'
  ]
}
export default {
  passthrough: state => state.passthrough,
  token: state => state.token,
  loggedUser: state => state.loggedUser,
  userProfile: state => state.userProfile,
  primaryRole: state => state.primaryRole,
  roles: state => state.roles,
  solutions: state => state.solutions,
  solution: state => state.solution,
  channelType: state => state.channelType,
  isAllowed: (state) => {
    return (page = '') => {
      var pageArray = page.split('/')
      var checkPage = ''
      var cnt = 0
      for (const item of pageArray) {
        if (item !== '' && cnt < 2) {
          if (isNaN(item)) {
            checkPage += '/' + item
          }
          cnt++
        }
      }
      // console.log('Current Page', { page: page, pageArray: pageArray, checkPage: checkPage })
      if (!PAGE_PERMISSIONS[checkPage]) {
        console.log('Page does not exist', checkPage)
        return false
      }
      if (state.roles && state.roles.length) {
        console.log('Checking Roles')
        return state.roles.some(r => PAGE_PERMISSIONS[checkPage].includes(r))
      }
      return false // PAGE_PERMISSIONS[page].includes('Guest')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js